import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Skeleton } from 'primeng/skeleton';
import { InputTextAreaInterface } from '../../../types/interfaces/input.interface';
import { TranslateSafePipe } from '../../pipes/translation.pipe';

@Component({
  selector: 'app-input-textarea',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    Skeleton,
    TranslateSafePipe,
  ],
  templateUrl: './input-textarea.html',
  styleUrls: [
    '../../styles/input-base.css',
    './input-textarea.css',
  ],
})
export class InputTextarea {
  @Input()
  public formData!: InputTextAreaInterface;

  @Input()
  public isLoading: boolean = false;

  public checkError(): boolean {
    if (!this.formData.formGroup) return true;

    return this.formData.formGroup
      .get(this.formData.id)
      ?.hasError('required') || false;
  }
}
